import { Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/login/login.page').then(m => m.LoginPage)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'planning-view/:id',
    canActivate: [AuthGuard],
    loadComponent: () => import('./planning-tab/planning-view/planning-view.page').then( m => m.PlanningViewPage)
  },
  {
    path: 'chat-view/:id',
    canActivate: [AuthGuard],
    loadComponent: () => import('./chat-tab/chat-view/chat-view.page').then( m => m.ChatViewPage)
  },
  {
    path: 'manual-usuario',
    canActivate: [AuthGuard],
    loadComponent: () => import('./manual-usuario/manual-usuario.page').then( m => m.ManualUsuarioPage)
  },
];